webpackJsonp([2],{

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_detect_browser__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_detect_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_detect_browser__);


var showAlertBrowserNotSupport = function showAlertBrowserNotSupport() {
  var alert = document.createElement('div');
  alert.className = 'alert alert-danger';
  alert.innerHTML = 'Ваш браузер сильно устарел или не поддерживается. Стабильная работа не гарантируется. Пожалуйста обновите свой браузер. Рекомендуется использовать <a href="https://www.google.ru/chrome/browser/desktop/index.html" target="_blank">Google Chrome</a> последней версии.';
  var s = document.body.firstChild;
  s.parentNode.insertBefore(alert, s);
};

var showAlertIENotSupport = function showAlertIENotSupport() {
  var alert = document.createElement('div');
  alert.className = 'alert alert-danger';
  alert.innerHTML = 'Вы используете бразуер Internet Explorer. Стабильная работа в нем не гаранитируется. Рекомендуется использовать <a href="https://www.google.ru/chrome/browser/desktop/index.html" target="_blank">Google Chrome</a> последней версии.';
  var s = document.body.firstChild;
  s.parentNode.insertBefore(alert, s);
};

var checkBrowser = function checkBrowser() {
  if (__WEBPACK_IMPORTED_MODULE_0_detect_browser___default.a) {
    switch (__WEBPACK_IMPORTED_MODULE_0_detect_browser___default.a.name) {
      case 'chrome':
        if (parseFloat(__WEBPACK_IMPORTED_MODULE_0_detect_browser___default.a.version) < 52) {
          showAlertBrowserNotSupport();
        }
        break;
      case 'ie':
        showAlertIENotSupport();
        break;
      case 'firefox':
        if (parseFloat(__WEBPACK_IMPORTED_MODULE_0_detect_browser___default.a.version) < 44) {
          showAlertBrowserNotSupport();
        }
        break;
      case 'opera':
        if (parseFloat(__WEBPACK_IMPORTED_MODULE_0_detect_browser___default.a.version) < 36) {
          showAlertBrowserNotSupport();
        }
        break;
      case 'safari':
        if (parseFloat(__WEBPACK_IMPORTED_MODULE_0_detect_browser___default.a.version) < 5) {
          showAlertBrowserNotSupport();
        }
        break;
    }
  }
};

document.body.onload = checkBrowser;

/***/ })

},[339]);


// WEBPACK FOOTER //
// static/js/detectBrowser.d135c327b6b262a217f2.js